import { useEffect, useRef, useState } from 'react';

//Primereact components
import { Toast } from 'primereact/toast';
import { Toolbar } from 'primereact/toolbar';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';

// Data table
import { defaultRowOptions, defaultPageRowOptions, paginatorLinks, showingEntries, Skeletonitems, SkeletonbodyTemplate, ACCOUNTGROUP, ACCOUNTTYPE } from '../../../appconfig/Settings';

import { AccountTabs } from '../../Account/AccountTabs';
import { getAllDetailsDirect, postAllData } from '../../../service/ProductService';
import { CREATEACCOUNT, GETACCOUNTS } from '../../../config/ApiConstant';
import { AccountMasterListColumns } from '../../../appconfig/DatatableSetting';
import { AddUpdateAccountMasterValidate } from '../../../config/Validate';

export const AccountMaster = () => {
    document.title = 'Account Master | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(true);
    const [accountsList, setAccountsList] = useState<any>([]);
    const [addUpdateModal, setAddUpdateModal] = useState<boolean>(false);
    const [addUpdateLoader, setAddUpdateLoader] = useState<boolean>(false);
    const [accountData, setAccountData] = useState<any>({});
    const [editId, setEditId] = useState<any>(null);
    const [errors, setErrors] = useState<any>({});

    // useEffect
    useEffect(() => {
        getAccountMasterData();

        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    // Get account master data
    const getAccountMasterData = async () => {
        try{
            setPageLoad(false);
            const response = await getAllDetailsDirect(GETACCOUNTS);
            if(response){
                setPageLoad(true);
                setAccountsList(response.List);
            }
        } catch (error: any) {
            setPageLoad(true);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // Global search
    const leftToolbarTemplate = () => {
        return (
            <>
                <span className="search-bar mr-3">
                    <i className="pi pi-search"></i>
                    <InputText type="search" className="search-input" onInput={(e) => setGlobalFilter(e.currentTarget.value)} placeholder="Search..." />
                </span>
                <Button
                    label="Add Account"
                    icon="pi pi-plus"
                    onClick={() => openAddAccountModal()}
                    className="ml-2">
                </Button>
            </>
        );
    };

    // Template for action
    const actionTemplate = (rowData: any) => {
        return(
            <>
                <div className="actions action-btn">
                    <Button
                        tooltip='Edit'
                        tooltipOptions={{position: "top"}}
                        icon="pi pi-pencil"
                        onClick={() => openEditAccountModal(rowData)}
                    />
                </div>
            </>
        )
    };

    //On Input Change
    const onInputChange = (e: any, name: string) => {
        let val;
        if (name == "accGroup" || name === "type") {
            val = e;
        } else {
            val = (e.target && e.target.value) || e.value || '';
        }
        setAccountData({ ...accountData, [name]: val });
    };

    // Open add account modal
    const openAddAccountModal = () => {
        setAddUpdateModal(true);
    };

    // Open edit account modal
    const openEditAccountModal = (rowData: any) => {
        setEditId(rowData.SrNo);
        let accountGroup = ACCOUNTGROUP.filter((item: any) => Number(item.code) === Number(rowData.GroupSrNo));
        let seelctedType = ACCOUNTTYPE.filter((item: any) => item.code === rowData.CrOrDb);
        setAccountData({
            accName: rowData.AccName,
            accGroup: accountGroup.length > 0 ? accountGroup[0] : "",
            type: seelctedType.length > 0 ? seelctedType[0] : "",
            openingbal: rowData.OpBalance
        });
        setAddUpdateModal(true);
    };

    // Close add update modal
    const closeAddUpdateModal = () => {
        setEditId(null);
        setAccountData({});
        setErrors({});
        setAddUpdateLoader(false);
        setAddUpdateModal(false);
    };

    // On submit add update account
    const onSubmitAddUpdateAccount = async () => {
        try{
            const { errors, isError } = AddUpdateAccountMasterValidate(accountData);
            setErrors(errors);

            //Check Error if no errors then call API
            if (!isError) {
                setAddUpdateLoader(true);

                //Request object
                let formData: any = new FormData();

                if(editId !== null){
                    formData.append("SrNo", editId);
                }else{
                    formData.append("SrNo", "");
                }

                formData.append("AccName", accountData.accName);
                formData.append("GroupSrNo", accountData.accGroup.code);
                formData.append("OpBalance", accountData.openingbal);
                formData.append("CrOrDb", accountData.type.code);

                //apicall
                const response = await postAllData(CREATEACCOUNT, formData);
                if (response && !window.cn(response)) {
                    setAccountData({});
                    setEditId(null);
                    setAddUpdateLoader(false);
                    setAddUpdateModal(false);
                    toast.current?.show({ severity: 'success', summary: 'Success', detail: response?.data });
                    setTimeout(() => {
                        getAccountMasterData();
                    }, 1500);
                }
            }
        } catch (error: any) {
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Something Went Wrong'
            });
        }
    };

    return(
        <>
            <AccountTabs mainTabLabel="Account Master" />
            <Toast ref={toast} />
            <div className="grid crud-demo mt-2">
                <div className="col-12">
                    <div className="card">
                        <Toolbar left={leftToolbarTemplate}></Toolbar>
                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={accountsList}
                                    showGridlines
                                    stripedRows
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    rows={defaultRowOptions}
                                    paginator={accountsList.length >= 10 && true}
                                    rowsPerPageOptions={defaultPageRowOptions}
                                    className="datatable-responsive p-datatable-sm"
                                    paginatorTemplate={paginatorLinks}
                                    currentPageReportTemplate={showingEntries}
                                    emptyMessage="No Data Found"
                                >
                                    {AccountMasterListColumns.map((col, i) => {
                                        if(col.field === "action"){
                                            return <Column key={col.field} field={col.field} header={col.header} body={actionTemplate} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} />;
                                        }
                                    })}
                                </DataTable>
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {AccountMasterListColumns.map((col, i) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>

            {/* Add Update Dialog */}
            <Dialog
                visible={addUpdateModal}
                className="p-fluid"
                style={{ width: "100vh" }}
                header={editId !== null ? "Edit Account" : "Add Account"}
                modal
                draggable={false} 
                resizable={false}
                footer={
                    <>
                        <Button
                            label="Cancel"
                            icon="pi pi-times"
                            className="p-button-secondary"
                            onClick={closeAddUpdateModal}
                        />
                        <Button
                            label="Submit"
                            icon="pi pi-check"
                            className="p-button-primary"
                            onClick={() => onSubmitAddUpdateAccount()}
                            loading={addUpdateLoader}
                        />
                    </>
                }
                onHide={closeAddUpdateModal}
            >
                <div className="formgrid grid">
                    <div className="field col-6">
                        <label htmlFor="accName">Account Name <span style={{ color: "red" }}>*</span></label>
                        <InputText
                            value={accountData?.accName}
                            name="accName"
                            autoComplete="off"
                            placeholder="Enter Account Name"
                            onChange={(e) => onInputChange(e, "accName")}
                            className={errors['accName'] && 'p-invalid'}
                        />
                        <small className="p-invalid-txt">{errors['accName']}</small>
                    </div>
                    <div className="field col-6">
                        <label htmlFor="openingbal">Opening Bal <span style={{ color: "red" }}>*</span></label>
                        <InputNumber
                            value={accountData?.openingbal}
                            name="openingbal"
                            useGrouping={false}
                            placeholder="Enter Opening Balance"
                            onChange={(e) => onInputChange(e, "openingbal")}
                            className={errors['openingbal'] && 'p-invalid'}
                        />
                        <small className="p-invalid-txt">{errors['openingbal']}</small>
                    </div>
                    <div className="field col-6">
                        <label htmlFor="accGroup">Account Group <span style={{ color: "red" }}>*</span></label>
                        <Dropdown
                            value={accountData?.accGroup}
                            name="accGroup"
                            options={ACCOUNTGROUP}
                            filter
                            optionLabel="name"
                            placeholder="Select Account Group"
                            onChange={(e) => onInputChange(e.value, "accGroup")}
                            className={errors['accGroup'] && 'p-invalid'}
                        />
                        <small className="p-invalid-txt">{errors['accGroup']}</small>
                    </div>
                    <div className="field col-6">
                        <label htmlFor="type">Select Type <span style={{ color: "red" }}>*</span></label>
                        <Dropdown
                            value={accountData?.type}
                            name="type"
                            options={ACCOUNTTYPE}
                            filter
                            optionLabel="name"
                            placeholder="Select Type"
                            onChange={(e) => onInputChange(e.value, "type")}
                            className={errors['type'] && 'p-invalid'}
                        />
                        <small className="p-invalid-txt">{errors['type']}</small>
                    </div>
                </div>
            </Dialog>
        </>
    )
};
